import styled from "styled-components";
import DesignConstants from "../../../../../constants/DesignConstants";

export const MainContentWrapper = styled.div`
    background: white;
    border-radius: ${DesignConstants.BORDER_RADIUS.SMALL_CONTAINER};
`;